/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Referral from './referral';
import ReferralDetail from './referral-detail';
import ReferralUpdate from './referral-update';
import ReferralDeleteDialog from './referral-delete-dialog';

const ReferralRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Referral />} />
    <Route path="new" element={<ReferralUpdate />} />
    <Route path=":id">
      <Route index element={<ReferralDetail />} />
      <Route path="edit" element={<ReferralUpdate />} />
      <Route path="delete" element={<ReferralDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ReferralRoutes;
